import React from "react";

import {
  GeoAltFill,
  TelephoneInboundFill,
  Envelope,
  Clock,
  Instagram,
  Facebook,
  Whatsapp,
  Linkedin,
} from "react-bootstrap-icons";

export default function Footer() {
  return (
    <>
      <footer className="text-center text-lg-start bg-light text-muted">
        <div className="container">
          <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
            <div className="me-5 d-none d-lg-block">
              <span>Get connected with us on social networks:</span>
            </div>
            <div>
              <a
                href="https://instagram.com/kairoscahayacemerlang?igshid=YmMyMTA2M2Y="
                className="me-4 link-secondary"
              >
                <Instagram color="#C24D70" width={22} height={22} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100083054365202"
                className="me-4 link-secondary"
              >
                <Facebook color="blue" width={22} height={22} />
              </a>
              <a
                href="https://wa.me/628118038707?text=Hallo Admin"
                className="me-4 link-secondary"
              >
                <Whatsapp color="green" width={22} height={22} />
              </a>
              <a
                href="https://www.linkedin.com/company/kairoscahayacemerang"
                className="me-4 link-secondary"
              >
                <Linkedin color="blue" width={22} height={22} />
              </a>
            </div>
          </section>
          <section>
            <div className="container text-center text-md-start mt-5">
              <div className="row mt-3">
                <div className="col-md-3 col-lg-4 col-xl-3 mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">
                    <i className="fas fa-gem text-secondary"></i>
                    3GINDONESIA
                  </h6>
                  <p>
                    Siap untuk meningkatkan bisnis Anda menjadi lebih baik ?
                  </p>
                  <a href="/hubungi-kami">
                    <button className="btn btn-danger">Hubungi Kami</button>
                  </a>
                </div>
                <div className="col-md-2 col-lg-2 col-xl-2 mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">Produk</h6>
                  <p>Aplikasi Phoenix</p>
                  <p>Outsourcing</p>
                  <p>Online & Offline Distribution</p>
                  <p>NusaCRM</p>
                  <p>EVENT</p>
                </div>
                <div className="col-md-3 col-lg-2 mx-auto col-xl-2 mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">Alamat Kami</h6>
                  <p>
                    <GeoAltFill /> Jl. Pluit Karang Permai II, Blok P9U/7.
                    <br />
                    Pluit, Jakarta Utara
                  </p>
                  <a
                    href="https://wa.me/628118038707?text=Hallo Admin"
                    class="text-decoration-none"
                  >
                    <TelephoneInboundFill /> (0811)-8038-707
                  </a>
                  <br />
                  <a
                    href="https://mail.google.com/mail/?view=cm&fs=1&to=email@domain.example"
                    class="text-decoration-none"
                  >
                    <Envelope /> info@3gindonesia.id
                  </a>
                  <br />
                  <br />
                  <Clock /> Senin - Jumat: 08.00 - 17.00
                </div>
                <div className="col-md-4 col-lg-3 col-xl-3 mb-md-0 mb-4">
                  <h6 className="text-uppercase fw-bold mb-4">Lokasi Kami</h6>
                  <div>
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d350.6408338550328!2d106.78233551016892!3d-6.124218342858477!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f36a262f1ea9%3A0xb0435b1ebaee2ebd!2sPT%20Kairos%20Cahaya%20Cemerlang!5e0!3m2!1sid!2sid!4v1663222939630!5m2!1sid!2sid"
                      width="100%"
                      height="100%"
                      target="_blank"
                      loading="lazy"
                      rel="noreferrer"
                      referrerpolicy="no-referrer-when-downgrade"
                      title="This is a unique title"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div
          className="text-center p-4"
          style={{
            backgroundColor: "RGB(211, 0, 50)",
            color: "white",
          }}
        >
          © 2022 Copyright 3GINDONESIA
        </div>
      </footer>
    </>
  );
}
